export const vimeoParse = {
    vmRegex: /^https:\/\/(www.)?vimeo.com(\/.*)?(\/video(s)?\/(?<accID>[A-z0-9]+))?\/(?<videoID>[A-z0-9]+)/,
    test(uri) {
        return this.vmRegex.test(uri)
    },
    parse(uri) {
        const {accID, videoID} = uri.match(this.vmRegex)?.groups
        if (accID) return `https://player.vimeo.com/video/${accID}?h=${videoID}`
        else return `https://player.vimeo.com/video/${videoID}`
    }
}

export const youtubeParse = {
    ytRegex: /^(https?:)?\/\/(www.)?youtube.com\/watch\?v=(?<videoID>[A-z0-9\-_]+)/,
    ytSregex: /^(https?:)?\/\/youtu.be\/(?<videoID>[A-z0-9\-_]+)/,
    test(uri) {
        return this.ytRegex.test(uri) || this.ytSregex.test(uri)
    },
    parse(uri) {
        const url = new URL(uri)
        if (this.ytRegex.test(uri)) return `${url.origin}/embed/${url.searchParams.get("v")}`
        
        const {videoID} = uri.match(this.ytSregex)?.groups
        return `https://www.youtube.com/embed/${videoID}`
    }
}

export default [vimeoParse, youtubeParse]